import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RegisteredEvents from "./RegisteredEvents";
import EditUserDialog from "../../../components/EditUserDialog/EditUserDialog";
import UserDialog from "./UserDialog/UserDialog";
import AssignUserEvent from "../../../components/AssignUserEvent/AssignUserEvent";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const SearchResults = ({ users, refresh }) => {
  const { userData } = React.useContext(EventContext);
  const [anchor, setAnchor] = React.useState(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [editUserOpen, setEditUserOpen] = React.useState(false);
  const [assignUserOpen, setAssignUserOpen] = React.useState(false);
  const [assignAction, setAssignAction] = React.useState(null);
  const [registeredDialogOpen, setRegisteredDialogOpen] = React.useState(false);
  const [eventType, setEventType] = React.useState(null);

  const handleOpen = (event, user) => {
    setAnchor(event.currentTarget);
    setMenuOpen(true);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setAnchor(null);
    setMenuOpen(false);
  };

  const handleDelete = (user) => {
    console.log("deleting user");
    setDialogOpen(true);
    setMenuOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedUser(null);
  };

  const deleteUser = async () => {
    setDialogOpen(false);

    const body = {
      userId: selectedUser._id,
    };

    const result = await request("users/delete", "post", body);
    if (!result.success) {
      return;
    }
    setSelectedUser(null);
    refresh();
    toast.success("User deleted successfully");
  };

  return (
    <>
      <List>
        {users.map((user, u) => {
          return (
            <div key={`${u}-${user._id}`}>
              <ListItem
                key={`listitem-${user._id}`}
                secondaryAction={
                  <MoreVertIcon onClick={(e) => handleOpen(e, user)} />
                }
              >
                <ListItemButton
                  onClick={() => {
                    setSelectedUser(user);
                    setEditUserOpen(true);
                  }}
                >
                  {user.email}
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
      <Menu anchorEl={anchor} open={menuOpen} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => {
            setEditUserOpen(true);
            setMenuOpen(false);
          }}
        >
          Edit Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRegisteredDialogOpen(true);
            setMenuOpen(false);
          }}
        >
          Show Registered Events
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            setAssignAction("assign");
            setAssignUserOpen(true);
            setMenuOpen(false);
          }}
        >
          Assign to Event
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAssignAction("remove");
            setAssignUserOpen(true);
            setMenuOpen(false);
          }}
        >
          Remove from Event
        </MenuItem>
        {userData?.org?.exchangeEventsActive
          ? [
              <Divider key="divider-exchange" />,
              <MenuItem
                key="assign-exchange-event"
                onClick={() => {
                  setAssignAction("assign");
                  setEventType("exchange");
                  setAssignUserOpen(true);
                  setMenuOpen(false);
                }}
              >
                Assign to Exchange Event
              </MenuItem>,
            ]
          : []}
        {userData?.org?.exchangeEventsActive
          ? [
              <MenuItem
              key="remove-exchange-event"
                onClick={() => {
                  setAssignAction("remove");
                  setEventType("exchange");
                  setAssignUserOpen(true);
                  setMenuOpen(false);
                }}
              >
                Remove from Exchange Event
              </MenuItem>,
            ]
          : []}
        <Divider />
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
      {/* <EditUserDialog
        open={editUserOpen}
        close={() => setEditUserOpen(false)}
        user={selectedUser}
      /> */}
      <UserDialog
        open={editUserOpen}
        close={() => {
          setSelectedUser(null);
          setEditUserOpen(false);
        }}
        user={selectedUser}
      />
      <AssignUserEvent
        open={assignUserOpen}
        close={() => {
          setEventType(null);
          setAssignUserOpen(false);
        }}
        user={selectedUser}
        action={assignAction}
        eventType={eventType}
      />
      <RegisteredEvents
        open={registeredDialogOpen}
        close={() => setRegisteredDialogOpen(false)}
        user={selectedUser}
      />
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete user?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deleting a user cannot be undone. There is no turning back. Everyone
            will hate you if you make the wrong choice.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={deleteUser} autoFocus>
            Delete them
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchResults;
